import SalariesLinesForm from '../../../../components/People/Salaries/Lines/SalaryLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function SalaryLinesModal(props) {
  const { remove, submit, update, visible, modalType, formRef, onCancel, removing, isUpdatable, submitting } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Salaries Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={!!isUpdatable}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <SalariesLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

SalaryLinesModal.propTypes = {}
SalaryLinesModal.defaultProps = {}

export default SalaryLinesModal
